// import React, { useContext, useEffect, useRef, useState } from "react";
// import { useLocation, } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import { ConfigContext } from "../../Context/ConfigContext";
// import { useParams } from "react-router-dom";
// import { OverlayLoader, Spinner } from "../../Components/Shimmers";
// import slugify from "slugify";
// import Carousel from "react-multi-carousel";
// import 'react-multi-carousel/lib/styles.css';
// import { Helmet } from "react-helmet";
// import UniCarSearch from "../Cars/UniCarSearch";
// import PartsHorizontalCard from "../../Components/Cards/PartsHorizontalCard";
// import OEBrandsCarousel from "./PartsComponent/OEBrandsCarousol";
// import { axiosGet } from "../../Apis/axiosMethods";
// import { default_image } from "../../Imgaes";

// const Parts = () => {
//   const { currency, business_type } = useContext(ConfigContext);
//   const location = useLocation();
//   const { t } = useTranslation();
//   const locale = localStorage.getItem("lang") ?? "en";
//   const { gdcURL } = useContext(ConfigContext);
//   const dir = localStorage.getItem("dir");

//   var { slug } = useParams();
//   const parts_slug = slug.split("-");
//   const STR_ID = parts_slug.pop();
//   const nameSlug = parts_slug
//     .join("-")
//     .replace(/\s+/g, "-");

//   const [loading, setLoading] = useState(false);
//   const [parts, setParts] = useState([]);

//   const [brands, setBrands] = useState([]);
//   const [selectedBrands, setSelectedBrands] = useState([]);
//   const [selectedBrandTags, setSelectedBrandTags] = useState([]);

//   const [next, setNext] = useState(false)
//   const [prev, setPrev] = useState(false)
//   const [TotalParts, setTotalParts] = useState(0);

//   const [limit] = useState(50);
//   const [TotalPages, setTotalPages] = useState(0);
//   const [page, setPage] = useState(1);
//   const [isSticky, setSticky] = useState(false);
//   const [selectedBrandsArray, setSelectedBrandsArray] = useState([]);
//   const [positions, setPositions] = useState([]);
//   const [selectedPositions, setSelectedPositions] = useState([]);
//   const [selectedOEBrandsArray, setSelectedOEBrandsArray] = useState([]);

//   const [oeBrands, setOEBrands] = useState([]);

//   const [responsive] = useState({
//     desktop: {
//       breakpoint: { max: 3000, min: 1024 },
//       items: 10,
//       slidesToSlide: 3, // optional, default to 1.
//     },
//     tablet: {
//       breakpoint: { max: 1024, min: 464 },
//       items: 4,
//       slidesToSlide: 2, // optional, default to 1.
//     },
//     mobile: {
//       breakpoint: { max: 464, min: 0 },
//       items: 3,
//       slidesToSlide: 1, // optional, default to 1.
//     },
//   });

//   useEffect(() => {
//     const fetchOEBrands = async () => {
//       try {
//         if (!STR_ID) return;

//         const pcId = localStorage.getItem("pc_id");

//         const url = pcId ? `/Parts/GetOEBrandsWithCar` : `/Dashboard/GetOEBrandsByNoCar`;

//         const strIdValue = Array.isArray(STR_ID) ? STR_ID[0] : STR_ID;

//         const params = {
//           str_id: strIdValue,
//         };

//         if (pcId) {
//           params.pc_id = pcId;
//         }

//         const response = await axiosGet(url, params);

//         if (response?.data?.success) {
//           setOEBrands(response.data.data || []);
//         } else {
//           setOEBrands([]);
//         }
//       } catch (error) {
//         console.error("Error fetching OE Brands:", error);
//         setOEBrands([]);
//       }
//     };

//     fetchOEBrands();
//   }, [STR_ID]);

//   useEffect(() => {
//     window.scrollTo(0, 0);
//     const pc_id = localStorage.getItem("pc_id");
//     if (!pc_id) {
//       window.location.href = `/Spare-Parts/Spare-Parts-nocar/${STR_ID}/${nameSlug}`;
//     }

//   }, [location]);

//   const [car_info] = useState(
//     localStorage.getItem("car_info")
//       ? JSON.parse(localStorage.getItem("car_info"))
//       : []
//   );
//   const [loadMore, setLoadMore] = useState(false);
//   const queryParams = new URLSearchParams(location.search);

//   useEffect(() => {
//     setSelectedBrands([]);
//     setSelectedBrandsArray([]);
//     setSelectedBrandTags([]);
//     setSelectedPositions([]);
//     setSelectedOEBrandsArray([]);
//   }, [location.pathname]);

//   const selectedPTID = queryParams.get('group');

//   useEffect(() => {
//     const fetchBrands = async () => {
//       try {
//         const response = await axiosGet(
//           `/Parts/GetBrandsWithCar`, {
//           pc_id: localStorage.getItem("pc_id"),
//           str_id: STR_ID,
//           lang: locale,
//           currency: currency,
//           limit: limit,
//           page: page,
//           pt_id: selectedPTID,
//           brands: selectedBrands,
//         }
//         );
//         if (response?.data?.success) {
//           const data = response.data;

//           setBrands(data.data || []);

//         }
//       } catch (error) {
//         console.error("Error fetching brands:", error);
//         setBrands([]);
//       }
//     };

//     fetchBrands();
//   }, [location]);

//   useEffect(() => {
//     fetch(`${gdcURL}/Parts/GetPositions?pc_id=${localStorage.getItem("pc_id")}&str_id=${STR_ID}&lang=${locale}&currency=${currency}&limit=${limit}&page=${page}&pt_id=${selectedPTID}&brands=${selectedBrands}`)
//       .then((res) => res.json())
//       .then((data) => {
//         setPositions(data.data);
//       });
//   }, []);

//   const LoadParts = async (pageNumber = page) => {
//     if (!localStorage.getItem("pc_id")) return;

//     try {
//       setLoading(true);

//       const response = await axiosGet(`/Parts/GetDepartmentPartsByWithCars`,
//         {
//           pc_id: localStorage.getItem("pc_id") ?? null,
//           str_id: Array.isArray(STR_ID) ? STR_ID[0] : STR_ID,
//           lang: locale ?? "en",
//           currency: currency ?? "aed",
//           limit,
//           page: pageNumber,
//           pt_id: selectedPTID,
//           brands: selectedBrands,
//           selectedBrands: selectedBrandsArray
//             ? JSON.stringify(selectedBrandsArray)
//             : "",
//           selectedPositions: selectedPositions
//             ? JSON.stringify(selectedPositions)
//             : "",
//           type: business_type,
//           selectedOEBrands: selectedOEBrandsArray ? JSON.stringify(selectedOEBrandsArray) : ""
//         }
//       );

//       setParts(response?.data.data);
//       setTotalPages(response?.data.total_pages);
//       setTotalParts(response?.data.total_records);
//       setPage(response?.data.page);
//       setPrev(response?.data.prev);
//       setNext(response?.data.next);

//     } catch (error) {
//       console.error("Fetch error:", error);
//     } finally {
//       setLoading(false);
//       setLoadMore(false);
//     }
//   };

//   const LoadMoreParts = async () => {
//     if (!localStorage.getItem("pc_id") || page >= TotalPages) return;
//     const nextPage = page + 1;

//     try {

//       setLoadMore(true);
//       isLoadMoreRef.current = true;

//       const response = await axiosGet(
//         `/Parts/GetDepartmentPartsByWithCars`,
//         {
//           pc_id: localStorage.getItem("pc_id"),
//           str_id: Array.isArray(STR_ID) ? STR_ID[0] : STR_ID,
//           lang: locale ?? "en",
//           currency: currency ?? "aed",
//           limit,
//           page: nextPage,
//           pt_id: selectedPTID,
//           brands: selectedBrands,

//           // ✅ IMPORTANT: add missing filters
//           selectedBrands: selectedBrandsArray
//             ? JSON.stringify(selectedBrandsArray)
//             : "",
//           selectedPositions: selectedPositions
//             ? JSON.stringify(selectedPositions)
//             : "",
//           selectedOEBrands: selectedOEBrandsArray
//             ? JSON.stringify(selectedOEBrandsArray)
//             : "",
//           type: business_type
//         }
//       );

//       // ✅ Prevent duplicates (based on unique key like ART_ID)
//       setParts((prev) => {
//         const existingStockNumbers = new Set(prev.map((item) => item.stock_number));
//         const newData = response?.data.data.filter(
//           (item) => !existingStockNumbers.has(item.stock_number)
//         );
//         return [...prev, ...newData];
//       });

//       setPage(nextPage);

//     } catch (error) {
//       console.error("Load more error:", error);
//     } finally {
//       setLoadMore(false);
//     }
//   };

//   const toggleBrand = (SUP_ID, SUP_BRAND, ART_TYPE) => {
//     setSelectedBrands((prevSelectedBrands) => {
//       if (prevSelectedBrands.includes(SUP_ID)) {
//         return prevSelectedBrands.filter((id) => id !== SUP_ID);
//       } else {
//         return [...prevSelectedBrands, SUP_ID];
//       }
//     });

//     setSelectedOEBrandsArray([]);

//     setSelectedBrandsArray((prevArray) => {
//       const index = prevArray.findIndex((item) => item.SUP_ID === SUP_ID);
//       if (index === -1) {
//         const newArray = [...prevArray, { SUP_ID, SUP_BRAND, ART_TYPE }];
//         return newArray;
//       } else {
//         const newArray = prevArray.filter((item) => item.SUP_ID !== SUP_ID);
//         return newArray;
//       }
//     });

//     let setSelectedBTs = [...selectedBrandTags];
//     const index = selectedBrandTags.findIndex((tag) => tag.SUP_ID === SUP_ID);
//     if (index === -1) {
//       setSelectedBTs.push({ SUP_ID, SUP_BRAND, ART_TYPE });
//     } else {
//       setSelectedBTs.splice(index, 1);
//     }

//     setSelectedBrandTags(setSelectedBTs);
//     setPage(1);
//   };

//   const togglePosition = (Position) => {
//     setSelectedPositions((prevSelectedPositions) => {
//       if (prevSelectedPositions.includes(Position)) {
//         return [];
//       } else {
//         return [Position];
//       }
//     });
//   };

//   const hasMounted = useRef(false);
//   const isLoadMoreRef = useRef(false);

//   useEffect(() => {
//     if (hasMounted.current) {
//       if (!isLoadMoreRef.current) {
//         LoadParts(page);
//       }
//       isLoadMoreRef.current = false;
//     } else {
//       hasMounted.current = true;
//     }
//   }, [selectedBrandTags, selectedPositions, location, selectedOEBrandsArray]);

//   const handlePageChange = (newPage) => {
//     if (newPage < 1 || newPage > TotalPages) return;

//     setPage(newPage);
//     LoadParts(newPage);

//     window.scrollTo({
//       top: 0,
//       behavior: "smooth",
//     });
//   };

//   const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
//     const { carouselState: { currentSlide } } = rest;
//     return (
//       <div className="carousel-button-group">
//         <button style={{ padding: '2px 6px', position: 'absolute', left: 0, top: '8px', marginLeft: '-40px' }} className={currentSlide === 0 ? 'btn btn-outline-dark btn-sm disable' : 'btn btn-outline-dark btn-sm '} onClick={() => previous()} > <i className="fas fa-chevron-left"></i> </button>
//         <button style={{ padding: '2px 6px', position: 'absolute', right: 0, top: '8px', marginRight: '-30px' }} className="btn btn-outline-dark btn-sm" onClick={() => next()} ><i className="fas fa-chevron-right"></i></button>
//       </div>
//     );
//   };

//   const BrandsTags = () => {
//     return parts && parts.length > 0 && localStorage.getItem("pc_id") &&
//       selectedBrandTags && (
//         <div>
//           <h6 style={{ lineHeight: 0, marginTop: "10px" }}>
//             {selectedBrandTags.length !== 0 && t("selected_filters")}
//           </h6>

//           {selectedBrandTags && selectedBrandTags.map((item, index) => {
//             return (
//               <span
//                 onClick={() =>
//                   toggleBrand(item.sup_id, item.sup_brand)
//                 }
//                 className="badge badge-pill  mr-4 pt-2 pb-2"
//                 style={{ backgroundColor: "#e9e9e9" }}
//                 key={`tags-${item.sup_id}`}>
//                 {item.sup_brand}{" "}
//                 <i className="fas fa-times-circle lightColorText"></i>{" "}
//               </span>
//             );
//           })}
//         </div>
//       )

//   }

//   const BrandsOptions = () => {
//     var divs = <div style={{ position: 'relative' }} className={`prevent-select ${selectedBrandTags && selectedBrandTags.length !== 0 && 'mt-2'}`}>
//       <Carousel
//         arrows={false}
//         renderButtonGroupOutside={brands.length > 10}
//         customButtonGroup={<ButtonGroup />}
//         responsive={responsive}
//         swipeable={true}
//         draggable={true}
//         showDots={false}
//         infinite={false}
//         autoPlaySpeed={1000}
//         keyBoardControl={true}
//         customTransition="all .5"
//         transitionDuration={500}
//         containerClass="carousel-container"
//         dotListClass="custom-dot-list-style"
//         itemClass="carousel-item-padding-40-px">
//         {brands &&
//           [...brands]
//             .sort((a, b) => selectedBrands.includes(b.sup_id) - selectedBrands.includes(a.sup_id))
//             .map((img, index) => {
//               return (
//                 <div
//                   key={`img-sup-brand-${index}`}
//                   onClick={() => {
//                     toggleBrand(
//                       img.sup_id,
//                       img.sup_brand.trim().replace(/[\r\n]/g, '').replace(/&/g, '__AMP__'),
//                       'IAM'
//                     );
//                     window.scrollTo(0, 0);
//                   }}
//                   style={{
//                     cursor: 'pointer',
//                     height: '40px',
//                     width: '80px',
//                     textAlign: 'center',
//                     border: selectedBrands.includes(img.sup_id)
//                       ? '2px solid #cc000b'
//                       : '0px solid #CCC',
//                   }}
//                 >
//                   <ImageWithFallback
//                     src={`${img.logo_url}`}
//                     alt={img.sup_brand}
//                     index={index}
//                     fallbackText={img.sup_brand}
//                     OE={false}
//                   />
//                 </div>
//               );
//             })}
//       </Carousel>
//     </div>
//     return divs;
//   };

//   useEffect(() => {
//     const handleScroll = () => {
//       const offset = window.scrollY;
//       if (offset > 200) { // Adjust this value as needed
//         setSticky(true);
//       } else {
//         setSticky(false);
//       }
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => {
//       window.removeEventListener('scroll', handleScroll);
//     };
//   }, []);

//   const [title, setTitle] = useState("Ghayar");

//   useEffect(() => {
//     try {
//       var tt = slug && slug.split("-") && slug.split("-").slice(0, -1).join(" ");
//       tt += " " + car_info && car_info[0] && car_info[0].TYPEL;
//       tt += " " + car_info && car_info[0] && car_info[0].sr_label;
//     } catch (err) {
//       setTitle('Ghayar');
//     }
//   }, [])

//   const getPageNumbers = () => {
//     const pages = [];
//     const maxVisible = 3; // kitne pages ek sath dikhane
//     let start = Math.max(1, page - 1);
//     let end = Math.min(TotalPages, page + 1);

//     // Start side dots
//     if (start > 2) {
//       pages.push(1);
//       pages.push("…");
//     } else if (start === 2) {
//       pages.push(1);
//     }

//     // Middle pages
//     for (let i = start; i <= end; i++) {
//       pages.push(i);
//     }

//     // End side dots
//     if (end < TotalPages - 1) {
//       pages.push("…");
//       pages.push(TotalPages);
//     } else if (end === TotalPages - 1) {
//       pages.push(TotalPages);
//     }

//     return pages;
//   };

//   return (
//     <>
//       {
//         loading ?
//           <div style={{ height: "100vh" }}>
//             <OverlayLoader />
//           </div>
//           :
//           <div
//             className="header-bottom  d-none d-lg-block"
//             style={{
//               borderBottom: "1px solid rgb(226, 226, 226)",
//               marginBottom: "10px",
//             }}>
//             <Helmet>
//               <title>{title}</title>
//             </Helmet>

//             <div className="container">
//               <nav
//                 className="main-nav w-100"
//                 style={{ textAlign: dir === "rtl" ? "right" : "left" }}>
//                 <div className="row justify-content-center">
//                   <div className="col-md-3">
//                     <UniCarSearch redirectURL={`/Spare-Parts/Spare-Parts-nocar/${STR_ID}/${title.replaceAll(" ", "-")}`} redirectRemoveURL={`/Spare-Parts/Catelog`} />
//                   </div>

//                   <div className="col-md-9">
//                     <h2 className="mt-2" style={{ color: '#132530', fontFamily: 'Montserrat, Arial, sans-serif', fontSize: '22px', fontWeight: '500', lineHeight: '24px' }}>
//                       {slug && slug.split("-").slice(0, -1).join(" ")} {car_info && car_info[0] && car_info[0].TYPEL} {car_info && car_info[0] && car_info[0].sr_label}
//                     </h2>

//                     <span className="mt-2" style={{ color: '#132530', fontFamily: 'Montserrat, Arial, sans-serif', fontSize: '14px', fontWeight: '500', lineHeight: '24px' }}>
//                       {t('best_department_for', { 'department': (slug && slug.split("-").slice(0, -1).join(" ")), 'car': car_info && car_info[0] && car_info[0].TYPEL })}

//                     </span>

//                     <div style={isSticky ? {
//                       position: 'fixed',
//                       top: '0',
//                       backgroundColor: '#FFF',
//                       width: '100%',
//                       left: '0',
//                       padding: '10px 50px',
//                       boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//                       zIndex: 10000000
//                     } : {}}>

//                       {isSticky ? (
//                         <div className="row">
//                           <div className="col-4" style={{
//                             color: '#59666e',
//                             fontFamily: 'Montserrat, Arial, sans-serif',
//                             fontSize: '12px',
//                             fontWeight: '500',
//                             lineHeight: '2',
//                             display: 'flex',
//                             alignItems: 'center',
//                             width: '100%',
//                             paddingRight: '3%'
//                           }}>
//                             {t('best_department_for', {
//                               department: slug && slug.split("-").slice(0, -1).join(" "),
//                               car: car_info && car_info[0] && car_info[0].TYPEL
//                             })}
//                           </div>

//                           <div className="col-8">
//                             <div className="mb-2">
//                               {Array.isArray(brands) && brands.length > 0 && <BrandsOptions />}
//                             </div>

//                             <OEBrandsCarousel
//                               brandsData={oeBrands}
//                               setSelectedOEBrandsArray={setSelectedOEBrandsArray}
//                               selectedOEBrandsArray={selectedOEBrandsArray}
//                               setPage={setPage}
//                               setAFMSelectedBrands={setSelectedBrands}
//                               setSelectedBrandsArray={setSelectedBrandsArray}
//                               isSticky={isSticky}
//                               setSelectedBrandTags={setSelectedBrandTags}
//                             />
//                           </div>
//                         </div>
//                       ) : (
//                         <div className={dir === 'rtl' ? "pr-5" : 'pl-5'}>
//                           {brands.length > 0 && (
//                             <h5 className="text-muted">Aftermarket Brands</h5>
//                           )}

//                           {Array.isArray(brands) && brands.length > 0 && <BrandsTags />}
//                           {Array.isArray(brands) && brands.length > 0 && <BrandsOptions />}

//                           <div className="mt-2">
//                             <OEBrandsCarousel
//                               brandsData={oeBrands}
//                               setSelectedOEBrandsArray={setSelectedOEBrandsArray}
//                               selectedOEBrandsArray={selectedOEBrandsArray}
//                               setPage={setPage}
//                               setAFMSelectedBrands={setSelectedBrands}
//                               setSelectedBrandsArray={setSelectedBrandsArray}
//                               isSticky={isSticky}
//                               setSelectedBrandTags={setSelectedBrandTags}
//                             />
//                           </div>
//                         </div>
//                       )}

//                     </div>


//                     {localStorage.getItem("pc_id") && (
//                       <div className="row">
//                         {positions && positions.length > 0 &&
//                           <div className="col-lg-12 mt-2">
//                             <span style={{ fontWeight: 500 }}>Fitting Position</span>
//                             <div className="mt-2" style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
//                               {positions.map((position, index) => (
//                                 <div
//                                   key={index}
//                                   style={{
//                                     display: "flex",
//                                     alignItems: "center",
//                                     gap: "15px",
//                                     background: "#f8f9fa", // light gray background
//                                     borderRadius: "10px",
//                                     padding: "8px 8px",
//                                     minWidth: "220px",
//                                     border: selectedPositions.includes(position.position) ? "2px solid #007bff" : "none",
//                                     cursor: "pointer"
//                                   }}
//                                   onClick={() => togglePosition(position.position)}
//                                 >
//                                   {/* Image */}
//                                   <img
//                                     src={position.image}
//                                     alt={position.position}
//                                     style={{ width: "60px", height: "auto", objectFit: "contain" }}
//                                   />

//                                   {/* Position name */}
//                                   <span style={{ fontSize: "12px", fontWeight: "500", color: "#0d1f2a" }}>
//                                     {position.position}
//                                   </span>
//                                 </div>
//                               ))}
//                             </div>
//                           </div>
//                         }

//                         <div className="container pt-5">
//                           {parts.length > 0 && t('total_items', { total: TotalParts ? TotalParts : 0 })}
//                         </div>

//                         <div className="row pb-4">
//                           {parts && parts.length > 0 && parts.map((part, index) => {
//                             const productSlug = slugify(
//                               (part?.PRODUCT_GROUP || part?.ART_PRODUCT_NAME || "-")
//                                 .replace(/,/g, "")
//                                 .toLowerCase()
//                             );

//                             const part_slug = `${productSlug}-${part.ART_SEARCH_NUMBER}-${part?.ART_SUP_ID}`

//                             const OE_part_slug = slugify(`${productSlug}`.toLowerCase()) +
//                               "-" +
//                               slugify(`${part.ART_SEARCH_NUMBER}`.toLowerCase())
//                               + `/${part?.ART_SUP_BRAND}`
//                               ;

//                             const partImg = part.MEDIA_SOURCE ? part?.MEDIA_SOURCE : default_image;
//                             return (part.VD_QTY > 0 &&
//                               <PartsHorizontalCard
//                                 key={`r-part-id-${part.ART_ID}-${index}`}
//                                 partImg={partImg}
//                                 criteria={part.ARTICLE_CRITERIA_JSON}
//                                 url={part.ART_TYPE === 'OENumber' ? `/OE-Spare-Parts/Details/${OE_part_slug}` : `/Spare-Parts/Details/${part_slug}`}
//                                 id={part.ART_ID}
//                                 title={part.PRODUCT_GROUP ?? part?.ART_PRODUCT_NAME}
//                                 number={part.ART_ARTICLE_NR}
//                                 price={part.VD_PRICE ?? 0}
//                                 display_price={part.display_price ?? 0}
//                                 mrp={part.VD_PRICE_MRP ?? 0}
//                                 display_price_mrp={part.display_price_mrp ?? 0}
//                                 qty={part.VD_QTY}
//                                 imgUrl={partImg}
//                                 action={true}
//                                 brand={part.stock_brand_name}
//                                 suplogo={part.SUP_LOGO_NAME}
//                                 supid={part.SUP_ID}
//                                 redLabel={3 === 3 ? `Aftermarket` : "Genuine"}
//                                 partInfo={part.ART_INFO}
//                                 pt_intl={part.PT_INTL}
//                                 art_type={part.ART_TYPE}
//                                 mfa_id={part.E_MFA_ID}
//                                 part={part}

//                                 SUP_WARRANTY={part?.SUP_WARRANTY}
//                                 stock_delivery_days={part?.stock_delivery_days}
//                               />
//                             );

//                           })}
//                         </div>
//                       </div>
//                     )}


//                     {loadMore && (
//                       <div className="text-center mt-2 mb-2">
//                         <Spinner />
//                       </div>
//                     )}

//                     <div className="col-lg-12 d-flex justify-content-center align-items-center">

//                       {/* Load More */}
//                       {TotalPages > 1 && (
//                         <div className="text-center mb-2">
//                           <button
//                             type="button"
//                             disabled={loadMore}
//                             className="btn btn-dark pl-5 pr-5 pt-3 pb-3"
//                             style={{ fontSize: "12px" }}
//                             onClick={(e) => {
//                               e.preventDefault();
//                               LoadMoreParts();
//                             }}
//                           >
//                             <i className="fas fa-redo mr-2"></i>
//                             {loadMore ? "Loading..." : t("load_more")}
//                           </button>
//                         </div>
//                       )}

//                       {
//                         TotalPages > 1 &&
//                         <div className="d-flex justify-content-center align-items-center mt-4 flex-wrap gap-3">

//                           {/* Pagination */}
//                           <nav>
//                             <ul className="selected-pagination">

//                               {/* Prev */}
//                               <li
//                                 className={`selected-page-btn ${page === 1 ? "disabled" : ""}`}
//                                 onClick={() => page > 1 && handlePageChange(page - 1)}
//                               >
//                                 ‹
//                               </li>

//                               {/* Page Numbers */}
//                               {getPageNumbers().map((p, index) => (
//                                 <li
//                                   key={index}
//                                   className={`selected-page-btn ${p === page ? "active" : ""
//                                     } ${p === "..." ? "dots" : ""}`}
//                                   onClick={() => p !== "..." && handlePageChange(p)}
//                                 >
//                                   {p}
//                                 </li>
//                               ))}

//                               {/* Next */}
//                               <li
//                                 className={`selected-page-btn ${page === TotalPages ? "disabled" : ""}`}
//                                 onClick={() => page < TotalPages && handlePageChange(page + 1)}
//                               >
//                                 ›
//                               </li>

//                             </ul>
//                           </nav>
//                         </div>
//                       }


//                       <style>
//                         {
//                           `
//     .selected-pagination {
//   display: flex;
//   list-style: none;
//   padding: 0;
//   gap: 10px;
// }

// .selected-page-btn {
//   width: 46px;
//   height: 46px;
//   border-radius: 12px;
//   border: 2px solid #e5e5e5;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   font-size: 18px;
//   font-weight: 600;
//   color: #333;
//   cursor: pointer;
//   background: #fff;
//   transition: all 0.2s ease;
// }

// .selected-page-btn:hover:not(.active):not(.disabled):not(.dots) {
//   border-color: #cc000b;
//   color: #cc000b;
// }

// .selected-page-btn.active {
//   background: #cc000b;
//   color: #fff;
//   border-color: #cc000b;
// }

// .selected-page-btn.disabled {
//   opacity: 0.4;
//   pointer-events: none;
// }

// .selected-page-btn.dots {
//   cursor: default;
//   font-size: 22px;
//   border: none;
// }

// /* Results text */
// .results-text {
//   font-size: 16px;
//   font-weight: 500;
//   color: #333;
// }

// /* Page size dropdown */
// .page-size-select {
//   border-radius: 14px;
//   padding: 10px 16px;
//   border: none;
//   background: #f1f1f3;
//   font-size: 16px;
//   font-weight: 600;
//   cursor: pointer;
// }

//     `
//                         }
//                       </style>


//                     </div>


//                   </div>

//                 </div>

//               </nav>
//             </div>

//             {/* End .container */}
//           </div>
//       }
//     </>
//   )
// };

// const ImageWithFallback = ({ src, index, alt, fallbackText, OE }) => {
//   const [imgError, setImgError] = useState(false);

//   const handleError = () => {
//     setImgError(true);
//   };
//   const fallbackStyle = {
//     textAlign: "center",
//     fontSize: "10px",
//     padding: "10px",
//     wordBreak: "break-word",
//     maxWidth: "90%",
//   };

//   const containerStyle = {
//     position: "relative",
//     width: "100%",
//     height: "30px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//   };
//   return (
//     <div style={containerStyle}>
//       {imgError ? (
//         <div style={fallbackStyle}>{fallbackText}</div>
//       ) : (
//         <img
//           draggable="false"
//           style={{
//             height: "30px",
//             margin: "auto",
//             float: "none",
//             marginTop: OE === false ? "5px" : 0,
//           }}
//           key={`img-part-${index}`}
//           src={src}
//           alt={alt}
//           onError={handleError}
//         />
//       )}
//     </div>
//   );
// };
// export default Parts;


import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ConfigContext } from "../../Context/ConfigContext";
import { OverlayLoader, Spinner } from "../../Components/Shimmers";
import slugify from "slugify";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Helmet } from "react-helmet";
import UniCarSearch from "../Cars/UniCarSearch";
import PartsHorizontalCard from "../../Components/Cards/PartsHorizontalCard";
import OEBrandsCarousel from "./PartsComponent/OEBrandsCarousol";
import { axiosGet } from "../../Apis/axiosMethods";
import { default_image } from "../../Imgaes";

const Parts = () => {
  const { currency, business_type } = useContext(ConfigContext);
  const location = useLocation();
  const navigate = useNavigate();                 // 🔹 new
  const { t } = useTranslation();
  const locale = localStorage.getItem("lang") ?? "en";
  const { gdcURL } = useContext(ConfigContext);
  const dir = localStorage.getItem("dir");

  const { slug } = useParams();
  const parts_slug = slug.split("-");
  const STR_ID = parts_slug.pop();
  const nameSlug = parts_slug.join("-").replace(/\s+/g, "-");

  const [loading, setLoading] = useState(false);
  const [parts, setParts] = useState([]);

  const [brands, setBrands] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedBrandTags, setSelectedBrandTags] = useState([]);

  const [next, setNext] = useState(false);
  const [prev, setPrev] = useState(false);
  const [TotalParts, setTotalParts] = useState(0);

  const [limit] = useState(50);
  const [TotalPages, setTotalPages] = useState(0);

  // 🔹 read the URL page up-front
  const queryParams = new URLSearchParams(location.search);
  const selectedPTID = queryParams.get("group");
  const pageFromUrl = Number(queryParams.get("page")) || 1;

  const [page, setPage] = useState(pageFromUrl);  // 🔹 was useState(1)

  const [isSticky, setSticky] = useState(false);
  const [selectedBrandsArray, setSelectedBrandsArray] = useState([]);
  const [positions, setPositions] = useState([]);
  const [selectedPositions, setSelectedPositions] = useState([]);
  const [selectedOEBrandsArray, setSelectedOEBrandsArray] = useState([]);

  const [oeBrands, setOEBrands] = useState([]);

  const [responsive] = useState({
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 10, slidesToSlide: 3 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 4, slidesToSlide: 2 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 3, slidesToSlide: 1 },
  });

  /* ---------------------------------------------------------------- */
  /* 🔹 URL ↔ page sync (page → ?page=)                               */
  /* ---------------------------------------------------------------- */
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const currentUrlPage = Number(params.get("page")) || 1;
    if (currentUrlPage === page) return;

    if (page === 1) params.delete("page");
    else params.set("page", page);

    navigate({ search: params.toString() }, { replace: true });
  }, [page, navigate, location.search]);

  /* ---------------------------------------------------------------- */
  /* OE brands                                                         */
  /* ---------------------------------------------------------------- */
  useEffect(() => {
    const fetchOEBrands = async () => {
      try {
        if (!STR_ID) return;
        const pcId = localStorage.getItem("pc_id");
        const url = pcId
          ? `/Parts/GetOEBrandsWithCar`
          : `/Dashboard/GetOEBrandsByNoCar`;
        const strIdValue = Array.isArray(STR_ID) ? STR_ID[0] : STR_ID;
        const params = { str_id: strIdValue };
        if (pcId) params.pc_id = pcId;

        const response = await axiosGet(url, params);
        if (response?.data?.success) {
          setOEBrands(response.data.data || []);
        } else {
          setOEBrands([]);
        }
      } catch (error) {
        console.error("Error fetching OE Brands:", error);
        setOEBrands([]);
      }
    };

    fetchOEBrands();
  }, [STR_ID]);

  /* ---------------------------------------------------------------- */
  /* Redirect if no car selected                                       */
  /* ---------------------------------------------------------------- */
  useEffect(() => {
    window.scrollTo(0, 0);
    const pc_id = localStorage.getItem("pc_id");
    if (!pc_id) {
      window.location.href = `/Spare-Parts/Spare-Parts-nocar/${STR_ID}/${nameSlug}`;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);                          // 🔹 was [location]

  const [car_info] = useState(
    localStorage.getItem("car_info")
      ? JSON.parse(localStorage.getItem("car_info"))
      : []
  );
  const [loadMore, setLoadMore] = useState(false);

  /* ---------------------------------------------------------------- */
  /* Reset filters when the route changes                              */
  /* ---------------------------------------------------------------- */
  useEffect(() => {
    setSelectedBrands([]);
    setSelectedBrandsArray([]);
    setSelectedBrandTags([]);
    setSelectedPositions([]);
    setSelectedOEBrandsArray([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  /* ---------------------------------------------------------------- */
  /* Brands                                                            */
  /* ---------------------------------------------------------------- */
  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await axiosGet(`/Parts/GetBrandsWithCar`, {
          pc_id: localStorage.getItem("pc_id"),
          str_id: STR_ID,
          lang: locale,
          currency: currency,
          limit: limit,
          page: page,
          pt_id: selectedPTID,
          brands: selectedBrands,
        });
        if (response?.data?.success) {
          setBrands(response.data.data || []);
        }
      } catch (error) {
        console.error("Error fetching brands:", error);
        setBrands([]);
      }
    };

    fetchBrands();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, selectedPTID]);            // 🔹 was [location]

  /* ---------------------------------------------------------------- */
  /* Positions                                                         */
  /* ---------------------------------------------------------------- */
  useEffect(() => {
    fetch(
      `${gdcURL}/Parts/GetPositions?pc_id=${localStorage.getItem(
        "pc_id"
      )}&str_id=${STR_ID}&lang=${locale}&currency=${currency}&limit=${limit}&page=${page}&pt_id=${selectedPTID}&brands=${selectedBrands}`
    )
      .then((res) => res.json())
      .then((data) => {
        setPositions(data.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* ---------------------------------------------------------------- */
  /* Loaders                                                           */
  /* ---------------------------------------------------------------- */
  const LoadParts = async (pageNumber = page) => {
    if (!localStorage.getItem("pc_id")) return;

    try {
      setLoading(true);

      const response = await axiosGet(`/Parts/GetDepartmentPartsByWithCars`, {
        pc_id: localStorage.getItem("pc_id") ?? null,
        str_id: Array.isArray(STR_ID) ? STR_ID[0] : STR_ID,
        lang: locale ?? "en",
        currency: currency ?? "aed",
        limit,
        page: pageNumber,
        pt_id: selectedPTID,
        brands: selectedBrands,
        selectedBrands: selectedBrandsArray
          ? JSON.stringify(selectedBrandsArray)
          : "",
        selectedPositions: selectedPositions
          ? JSON.stringify(selectedPositions)
          : "",
        type: business_type,
        selectedOEBrands: selectedOEBrandsArray
          ? JSON.stringify(selectedOEBrandsArray)
          : "",
      });

      setParts(response?.data.data);
      setTotalPages(response?.data.total_pages);
      setTotalParts(response?.data.total_records);
      setPage(response?.data.page);
      setPrev(response?.data.prev);
      setNext(response?.data.next);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
      setLoadMore(false);
    }
  };

  const isLoadMoreRef = useRef(false);
  const hasMounted = useRef(false);

  const LoadMoreParts = async () => {
    if (!localStorage.getItem("pc_id") || page >= TotalPages) return;
    const nextPage = page + 1;

    try {
      setLoadMore(true);
      isLoadMoreRef.current = true;

      const response = await axiosGet(`/Parts/GetDepartmentPartsByWithCars`, {
        pc_id: localStorage.getItem("pc_id"),
        str_id: Array.isArray(STR_ID) ? STR_ID[0] : STR_ID,
        lang: locale ?? "en",
        currency: currency ?? "aed",
        limit,
        page: nextPage,
        pt_id: selectedPTID,
        brands: selectedBrands,
        selectedBrands: selectedBrandsArray
          ? JSON.stringify(selectedBrandsArray)
          : "",
        selectedPositions: selectedPositions
          ? JSON.stringify(selectedPositions)
          : "",
        selectedOEBrands: selectedOEBrandsArray
          ? JSON.stringify(selectedOEBrandsArray)
          : "",
        type: business_type,
      });

      setParts((prevParts) => {
        const existing = new Set(prevParts.map((item) => item.stock_number));
        const newData = response?.data.data.filter(
          (item) => !existing.has(item.stock_number)
        );
        return [...prevParts, ...newData];
      });

      setPage(nextPage);
    } catch (error) {
      console.error("Load more error:", error);
    } finally {
      setLoadMore(false);
    }
  };

  /* ---------------------------------------------------------------- */
  /* Handlers                                                          */
  /* ---------------------------------------------------------------- */
  const toggleBrand = (SUP_ID, SUP_BRAND, ART_TYPE) => {
    setSelectedBrands((prevSelectedBrands) => {
      if (prevSelectedBrands.includes(SUP_ID)) {
        return prevSelectedBrands.filter((id) => id !== SUP_ID);
      }
      return [...prevSelectedBrands, SUP_ID];
    });

    setSelectedOEBrandsArray([]);

    setSelectedBrandsArray((prevArray) => {
      const index = prevArray.findIndex((item) => item.SUP_ID === SUP_ID);
      if (index === -1) {
        return [...prevArray, { SUP_ID, SUP_BRAND, ART_TYPE }];
      }
      return prevArray.filter((item) => item.SUP_ID !== SUP_ID);
    });

    const nextTags = [...selectedBrandTags];
    const idx = selectedBrandTags.findIndex((tag) => tag.SUP_ID === SUP_ID);
    if (idx === -1) nextTags.push({ SUP_ID, SUP_BRAND, ART_TYPE });
    else nextTags.splice(idx, 1);

    setSelectedBrandTags(nextTags);
    setPage(1);
  };

  const togglePosition = (Position) => {
    setSelectedPositions((prevSelectedPositions) => {
      if (prevSelectedPositions.includes(Position)) return [];
      return [Position];
    });
  };

  /* ---------------------------------------------------------------- */
  /* 🔹 Reload on filters / route change (skip the very first mount)  */
  /* ---------------------------------------------------------------- */
  useEffect(() => {
    if (hasMounted.current) {
      if (!isLoadMoreRef.current) {
        LoadParts(page);
      }
      isLoadMoreRef.current = false;
    } else {
      hasMounted.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedBrandTags,
    selectedPositions,
    selectedOEBrandsArray,
    location.pathname,   // 🔹 was `location`
    selectedPTID,        // 🔹 `?group=` changes should reload
  ]);

  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > TotalPages) return;
    setPage(newPage);
    LoadParts(newPage);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  /* ---------------------------------------------------------------- */
  /* Small components                                                  */
  /* ---------------------------------------------------------------- */
  const ButtonGroup = ({ next, previous, ...rest }) => {
    const {
      carouselState: { currentSlide },
    } = rest;
    return (
      <div className="carousel-button-group">
        <button
          style={{
            padding: "2px 6px",
            position: "absolute",
            left: 0,
            top: "8px",
            marginLeft: "-40px",
          }}
          className={
            currentSlide === 0
              ? "btn btn-outline-dark btn-sm disable"
              : "btn btn-outline-dark btn-sm "
          }
          onClick={() => previous()}
        >
          <i className="fas fa-chevron-left"></i>
        </button>
        <button
          style={{
            padding: "2px 6px",
            position: "absolute",
            right: 0,
            top: "8px",
            marginRight: "-30px",
          }}
          className="btn btn-outline-dark btn-sm"
          onClick={() => next()}
        >
          <i className="fas fa-chevron-right"></i>
        </button>
      </div>
    );
  };

  const BrandsTags = () => {
    return (
      parts &&
      parts.length > 0 &&
      localStorage.getItem("pc_id") &&
      selectedBrandTags && (
        <div>
          <h6 style={{ lineHeight: 0, marginTop: "10px" }}>
            {selectedBrandTags.length !== 0 && t("selected_filters")}
          </h6>
          {selectedBrandTags.map((item) => (
            <span
              onClick={() => toggleBrand(item.sup_id, item.sup_brand)}
              className="badge badge-pill mr-4 pt-2 pb-2"
              style={{ backgroundColor: "#e9e9e9" }}
              key={`tags-${item.sup_id}`}
            >
              {item.sup_brand}{" "}
              <i className="fas fa-times-circle lightColorText"></i>{" "}
            </span>
          ))}
        </div>
      )
    );
  };

  const BrandsOptions = () => (
    <div
      style={{ position: "relative" }}
      className={`prevent-select ${selectedBrandTags && selectedBrandTags.length !== 0 && "mt-2"
        }`}
    >
      <Carousel
        arrows={false}
        renderButtonGroupOutside={brands.length > 10}
        customButtonGroup={<ButtonGroup />}
        responsive={responsive}
        swipeable
        draggable
        showDots={false}
        infinite={false}
        autoPlaySpeed={1000}
        keyBoardControl
        customTransition="all .5"
        transitionDuration={500}
        containerClass="carousel-container"
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px"
      >
        {brands &&
          [...brands]
            .sort(
              (a, b) =>
                selectedBrands.includes(b.sup_id) -
                selectedBrands.includes(a.sup_id)
            )
            .map((img, index) => (
              <div
                key={`img-sup-brand-${index}`}
                onClick={() => {
                  toggleBrand(
                    img.sup_id,
                    img.sup_brand.trim().replace(/[\r\n]/g, "").replace(/&/g, "__AMP__"),
                    "IAM"
                  );
                  window.scrollTo(0, 0);
                }}
                style={{
                  cursor: "pointer",
                  height: "40px",
                  width: "80px",
                  textAlign: "center",
                  border: selectedBrands.includes(img.sup_id)
                    ? "2px solid #cc000b"
                    : "0px solid #CCC",
                }}
              >
                <ImageWithFallback
                  src={`${img.logo_url}`}
                  alt={img.sup_brand}
                  index={index}
                  fallbackText={img.sup_brand}
                  OE={false}
                />
              </div>
            ))}
      </Carousel>
    </div>
  );

  /* ---------------------------------------------------------------- */
  /* Sticky header                                                     */
  /* ---------------------------------------------------------------- */
  useEffect(() => {
    const handleScroll = () => setSticky(window.scrollY > 200);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [title, setTitle] = useState("Ghayar");

  useEffect(() => {
    try {
      let tt = slug && slug.split("-").slice(0, -1).join(" ");
      tt += " " + car_info && car_info[0] && car_info[0].TYPEL;
      tt += " " + car_info && car_info[0] && car_info[0].sr_label;
    } catch (err) {
      setTitle("Ghayar");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* ---------------------------------------------------------------- */
  /* Pagination numbers                                                */
  /* ---------------------------------------------------------------- */
  const getPageNumbers = () => {
    const pages = [];
    const start = Math.max(1, page - 1);
    const end = Math.min(TotalPages, page + 1);

    if (start > 2) {
      pages.push(1);
      pages.push("…");
    } else if (start === 2) {
      pages.push(1);
    }

    for (let i = start; i <= end; i++) pages.push(i);

    if (end < TotalPages - 1) {
      pages.push("…");
      pages.push(TotalPages);
    } else if (end === TotalPages - 1) {
      pages.push(TotalPages);
    }
    return pages;
  };

  /* ---------------------------------------------------------------- */
  /* Render                                                            */
  /* ---------------------------------------------------------------- */
  return (
    <>
      {loading ? (
        <div style={{ height: "100vh" }}>
          <OverlayLoader />
        </div>
      ) : (
        <div
          className="header-bottom d-none d-lg-block"
          style={{
            borderBottom: "1px solid rgb(226, 226, 226)",
            marginBottom: "10px",
          }}
        >
          <Helmet>
            <title>{title}</title>
          </Helmet>

          <div className="container">
            <nav
              className="main-nav w-100"
              style={{ textAlign: dir === "rtl" ? "right" : "left" }}
            >
              <div className="row justify-content-center">
                <div className="col-md-3">
                  <UniCarSearch
                    redirectURL={`/Spare-Parts/Spare-Parts-nocar/${STR_ID}/${title.replaceAll(
                      " ",
                      "-"
                    )}`}
                    redirectRemoveURL={`/Spare-Parts/Catelog`}
                  />
                </div>

                <div className="col-md-9">
                  <h2
                    className="mt-2"
                    style={{
                      color: "#132530",
                      fontFamily: "Montserrat, Arial, sans-serif",
                      fontSize: "22px",
                      fontWeight: "500",
                      lineHeight: "24px",
                    }}
                  >
                    {slug && slug.split("-").slice(0, -1).join(" ")}{" "}
                    {car_info && car_info[0] && car_info[0].TYPEL}{" "}
                    {car_info && car_info[0] && car_info[0].sr_label}
                  </h2>

                  <span
                    className="mt-2"
                    style={{
                      color: "#132530",
                      fontFamily: "Montserrat, Arial, sans-serif",
                      fontSize: "14px",
                      fontWeight: "500",
                      lineHeight: "24px",
                    }}
                  >
                    {t("best_department_for", {
                      department:
                        slug && slug.split("-").slice(0, -1).join(" "),
                      car: car_info && car_info[0] && car_info[0].TYPEL,
                    })}
                  </span>

                  <div
                    style={
                      isSticky
                        ? {
                          position: "fixed",
                          top: "0",
                          backgroundColor: "#FFF",
                          width: "100%",
                          left: "0",
                          padding: "10px 50px",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                          zIndex: 10000000,
                        }
                        : {}
                    }
                  >
                    {isSticky ? (
                      <div className="row">
                        <div
                          className="col-4"
                          style={{
                            color: "#59666e",
                            fontFamily: "Montserrat, Arial, sans-serif",
                            fontSize: "12px",
                            fontWeight: "500",
                            lineHeight: "2",
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                            paddingRight: "3%",
                          }}
                        >
                          {t("best_department_for", {
                            department:
                              slug && slug.split("-").slice(0, -1).join(" "),
                            car: car_info && car_info[0] && car_info[0].TYPEL,
                          })}
                        </div>

                        <div className="col-8">
                          <div className="mb-2">
                            {Array.isArray(brands) && brands.length > 0 && (
                              <BrandsOptions />
                            )}
                          </div>

                          <OEBrandsCarousel
                            brandsData={oeBrands}
                            setSelectedOEBrandsArray={setSelectedOEBrandsArray}
                            selectedOEBrandsArray={selectedOEBrandsArray}
                            setPage={setPage}
                            setAFMSelectedBrands={setSelectedBrands}
                            setSelectedBrandsArray={setSelectedBrandsArray}
                            isSticky={isSticky}
                            setSelectedBrandTags={setSelectedBrandTags}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className={dir === "rtl" ? "pr-5" : "pl-5"}>
                        {brands.length > 0 && (
                          <h5 className="text-muted">Aftermarket Brands</h5>
                        )}
                        {Array.isArray(brands) && brands.length > 0 && <BrandsTags />}
                        {Array.isArray(brands) && brands.length > 0 && <BrandsOptions />}
                        <div className="mt-2">
                          <OEBrandsCarousel
                            brandsData={oeBrands}
                            setSelectedOEBrandsArray={setSelectedOEBrandsArray}
                            selectedOEBrandsArray={selectedOEBrandsArray}
                            setPage={setPage}
                            setAFMSelectedBrands={setSelectedBrands}
                            setSelectedBrandsArray={setSelectedBrandsArray}
                            isSticky={isSticky}
                            setSelectedBrandTags={setSelectedBrandTags}
                          />
                        </div>
                      </div>
                    )}
                  </div>

                  {localStorage.getItem("pc_id") && (
                    <div className="row">
                      {positions && positions.length > 0 && (
                        <div className="col-lg-12 mt-2">
                          <span style={{ fontWeight: 500 }}>Fitting Position</span>
                          <div
                            className="mt-2"
                            style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}
                          >
                            {positions.map((position, index) => (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "15px",
                                  background: "#f8f9fa",
                                  borderRadius: "10px",
                                  padding: "8px 8px",
                                  minWidth: "220px",
                                  border: selectedPositions.includes(position.position)
                                    ? "2px solid #007bff"
                                    : "none",
                                  cursor: "pointer",
                                }}
                                onClick={() => togglePosition(position.position)}
                              >
                                <img
                                  src={position.image}
                                  alt={position.position}
                                  style={{
                                    width: "60px",
                                    height: "auto",
                                    objectFit: "contain",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    color: "#0d1f2a",
                                  }}
                                >
                                  {position.position}
                                </span>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      <div className="container pt-5">
                        {parts.length > 0 &&
                          t("total_items", {
                            total: TotalParts ? TotalParts : 0,
                          })}
                      </div>

                      <div className="row pb-4">
                        {parts &&
                          parts.length > 0 &&
                          parts.map((part, index) => {
                            if (part.VD_QTY <= 0) return null;

                            const productSlug = slugify(
                              (part?.PRODUCT_GROUP || part?.ART_PRODUCT_NAME || "-")
                                .replace(/,/g, "")
                                .toLowerCase()
                            );

                            const part_slug = `${productSlug}-${part.ART_SEARCH_NUMBER}-${part?.ART_SUP_ID}`;

                            const OE_part_slug =
                              slugify(`${productSlug}`.toLowerCase()) +
                              "-" +
                              slugify(`${part.ART_SEARCH_NUMBER}`.toLowerCase()) +
                              `/${part?.ART_SUP_BRAND}`;

                            const partImg = part.MEDIA_SOURCE
                              ? part?.MEDIA_SOURCE
                              : default_image;

                            return (
                              <PartsHorizontalCard
                                key={`r-part-id-${part.ART_ID}-${index}`}
                                partImg={partImg}
                                criteria={part.ARTICLE_CRITERIA_JSON}
                                url={
                                  part.ART_TYPE === "OENumber"
                                    ? `/OE-Spare-Parts/Details/${OE_part_slug}`
                                    : `/Spare-Parts/Details/${part_slug}`
                                }
                                id={part.ART_ID}
                                title={part.PRODUCT_GROUP ?? part?.ART_PRODUCT_NAME}
                                number={part.ART_ARTICLE_NR}
                                price={part.VD_PRICE ?? 0}
                                display_price={part.display_price ?? 0}
                                mrp={part.VD_PRICE_MRP ?? 0}
                                display_price_mrp={part.display_price_mrp ?? 0}
                                qty={part.VD_QTY}
                                imgUrl={partImg}
                                action={true}
                                brand={part.stock_brand_name}
                                suplogo={part.SUP_LOGO_NAME}
                                supid={part.SUP_ID}
                                redLabel="Aftermarket"
                                partInfo={part.ART_INFO}
                                pt_intl={part.PT_INTL}
                                art_type={part.ART_TYPE}
                                mfa_id={part.E_MFA_ID}
                                part={part}
                                SUP_WARRANTY={part?.SUP_WARRANTY}
                                stock_delivery_days={part?.stock_delivery_days}
                              />
                            );
                          })}
                      </div>
                    </div>
                  )}

                  {loadMore && (
                    <div className="text-center mt-2 mb-2">
                      <Spinner />
                    </div>
                  )}

                  <div className="col-lg-12 d-flex justify-content-center align-items-center">
                    {TotalPages > 1 && (
                      <div className="text-center mb-2">
                        <button
                          type="button"
                          disabled={loadMore}
                          className="btn btn-dark pl-5 pr-5 pt-3 pb-3"
                          style={{ fontSize: "12px" }}
                          onClick={(e) => {
                            e.preventDefault();
                            LoadMoreParts();
                          }}
                        >
                          <i className="fas fa-redo mr-2"></i>
                          {loadMore ? "Loading..." : t("load_more")}
                        </button>
                      </div>
                    )}

                    {TotalPages > 1 && (
                      <div className="d-flex justify-content-center align-items-center mt-4 flex-wrap gap-3">
                        <nav>
                          <ul className="selected-pagination">
                            <li
                              className={`selected-page-btn ${page === 1 ? "disabled" : ""
                                }`}
                              onClick={() => page > 1 && handlePageChange(page - 1)}
                            >
                              ‹
                            </li>

                            {getPageNumbers().map((p, index) => (
                              <li
                                key={index}
                                className={`selected-page-btn ${p === page ? "active" : ""
                                  } ${p === "..." ? "dots" : ""}`}
                                onClick={() => p !== "..." && handlePageChange(p)}
                              >
                                {p}
                              </li>
                            ))}

                            <li
                              className={`selected-page-btn ${page === TotalPages ? "disabled" : ""
                                }`}
                              onClick={() =>
                                page < TotalPages && handlePageChange(page + 1)
                              }
                            >
                              ›
                            </li>
                          </ul>
                        </nav>
                      </div>
                    )}

                    <style>
                      {`
                        .selected-pagination {
                          display: flex;
                          list-style: none;
                          padding: 0;
                          gap: 10px;
                        }
                        .selected-page-btn {
                          width: 46px;
                          height: 46px;
                          border-radius: 12px;
                          border: 2px solid #e5e5e5;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          font-size: 18px;
                          font-weight: 600;
                          color: #333;
                          cursor: pointer;
                          background: #fff;
                          transition: all 0.2s ease;
                        }
                        .selected-page-btn:hover:not(.active):not(.disabled):not(.dots) {
                          border-color: #cc000b;
                          color: #cc000b;
                        }
                        .selected-page-btn.active {
                          background: #cc000b;
                          color: #fff;
                          border-color: #cc000b;
                        }
                        .selected-page-btn.disabled {
                          opacity: 0.4;
                          pointer-events: none;
                        }
                        .selected-page-btn.dots {
                          cursor: default;
                          font-size: 22px;
                          border: none;
                        }
                        .results-text {
                          font-size: 16px;
                          font-weight: 500;
                          color: #333;
                        }
                        .page-size-select {
                          border-radius: 14px;
                          padding: 10px 16px;
                          border: none;
                          background: #f1f1f3;
                          font-size: 16px;
                          font-weight: 600;
                          cursor: pointer;
                        }
                      `}
                    </style>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
      )}
    </>
  );
};

const ImageWithFallback = ({ src, index, alt, fallbackText, OE }) => {
  const [imgError, setImgError] = useState(false);
  const handleError = () => setImgError(true);

  const fallbackStyle = {
    textAlign: "center",
    fontSize: "10px",
    padding: "10px",
    wordBreak: "break-word",
    maxWidth: "90%",
  };

  const containerStyle = {
    position: "relative",
    width: "100%",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  return (
    <div style={containerStyle}>
      {imgError ? (
        <div style={fallbackStyle}>{fallbackText}</div>
      ) : (
        <img
          draggable="false"
          style={{
            height: "30px",
            margin: "auto",
            float: "none",
            marginTop: OE === false ? "5px" : 0,
          }}
          key={`img-part-${index}`}
          src={src}
          alt={alt}
          onError={handleError}
        />
      )}
    </div>
  );
};

export default Parts;